var map = {
	"./gallery1.png": 8734,
	"./gallery10.png": 3772,
	"./gallery11.png": 5397,
	"./gallery12.png": 5022,
	"./gallery13.png": 807,
	"./gallery14.png": 1192,
	"./gallery15.png": 9585,
	"./gallery16.png": 3338,
	"./gallery17.png": 3171,
	"./gallery18.png": 2980,
	"./gallery19.png": 6221,
	"./gallery2.png": 7509,
	"./gallery20.png": 8929,
	"./gallery21.png": 6216,
	"./gallery3.png": 3644,
	"./gallery4.png": 3603,
	"./gallery5.png": 2842,
	"./gallery6.png": 1825,
	"./gallery7.png": 9112,
	"./gallery8.png": 767,
	"./gallery9.png": 5670,
	"./gallerycover.png": 6646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7472;